var React = require('react');

function Reply (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.243424 5.56396L5.39967 1.1372C5.85114 0.747552 6.56246 1.06369 6.56246 1.66923V4.01445C11.2675 4.04052 15 4.98388 15 9.44287C15 11.2429 13.8401 13.0259 12.5584 13.9575C12.1582 14.2487 11.5889 13.8834 11.7363 13.412C13.0646 9.16396 11.1064 8.03603 6.56246 7.96865V10.5444C6.56246 11.1509 5.85026 11.4658 5.39967 11.0765L0.243424 6.6497C-0.0806871 6.34619 -0.0815953 5.84228 0.243424 5.56396Z","fill":"#878787"}));
}

Reply.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Reply;

Reply.default = Reply;
